import { NamedEntity, NamedEntityDefault } from "./base/NamedEntity";
import InvoiceMirror, { InvoiceMirrorDefaultProps } from "./InvoiceMirror";
import TransactionInvoiceInfo, {TransactionInvoiceInfoProps} from "./TransactionInvoiceInfo";
import TransactionItemDimension from "./TransactionItemDimension";

export default interface TransactionItem {
  id: number;
  trans: number;
  accDate: Date | string;
  user: NamedEntity;
  bookingUser: string;
  bookType: NamedEntity;
  bookingDate: Date | null;
  dim1Code: NamedEntity;
  dim2Code: NamedEntity;
  dim3Code: NamedEntity;
  accSign: string;
  invoiceMirror: InvoiceMirror;
  insDate: Date | string;
  invNo: number;
  partner: number;
  productionId: number;
  productionNumber: string;
  productionExtCode: string;
  note: string | null;
  remark: string | null;
  isHasDimensions: boolean;
  showDimensions: boolean;
  prefix: string;
  total: number;
  currency: string;
  currTotal: number;
  exchangeRate: number;
  period: number;
  project: object;
  planId: number;
  car: number;
  prcar: number;
  postCalc: number;
  workNumber: string | null;
    seqNumber: string;
  specDim1: string;
  specDim2: string;
  specDim3: string;
  specDim4: string;

  inEdit: boolean;
  selected: boolean;
  deleting: boolean;
  newTransactionItemDimensions: TransactionItemDimension[];
  invoiceInfo: TransactionInvoiceInfo;

  // dimensions: TransactionItemDimensions | null;
}

export const TransactionItemDefaultProps: TransactionItem = {
  id: 0,
  trans: 1,
  accDate: new Date(),
  user: NamedEntityDefault,
  bookingUser: "-",
  bookType: {id:11, name:"Vegyes könyvelés"},
  bookingDate: null,
  dim1Code: NamedEntityDefault,
  dim2Code: NamedEntityDefault,
  dim3Code: NamedEntityDefault,
  accSign: "-",
  invoiceMirror: InvoiceMirrorDefaultProps,
  insDate: new Date(),
  invNo: 1,
  partner: 1,
  productionId: 1,
  productionNumber: "-",
  productionExtCode: "-",
  note: null,
  remark: null,
  isHasDimensions: false,
  showDimensions: false,
  prefix: "MANU",
  total: 0,
  currency: "HUF",
  currTotal: 0,
  exchangeRate: 1,
  project: {id: 1, mainCode: "-", code: "-", name: "-", poWorkNumber: null, poNumber: null, poExtCode: null, partnerName: null, partnerExtCode: null, isCustorder: false},
  period: 1,
  planId: 1,
  car: 1,
  prcar: 1,
  postCalc: 1,
  workNumber: null,
  seqNumber: "-",

  specDim1: "",
  specDim2: "",
  specDim3: "",
  specDim4: "",

  inEdit: false,
  selected: false,
  deleting: false,
  newTransactionItemDimensions: [],
  invoiceInfo: TransactionInvoiceInfoProps,
  // dimensions: null
};